import React from 'react';

export default function LoadingState({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-8">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4" />
      <p className="text-gray-500 text-sm">{message}</p>
    </div>
  );
}
